export default "__VITE_ASSET__6tfaUaaQhhdOF3mU90utlQ__"